import React, { Component } from 'react';
import './HomeStyles.css'

export class Home extends Component {
    static displayName = Home.name;
    render() {

        const ops = ['GCP', 'K8s', 'HELM', 'VERCEL', 'Docker', 'Jenkins', 'Webhooks']
        const FE = ['React.JS', 'Next.JS', 'MAUI (C#)', 'SWIFT', 'MUI & Bootstrap', 'Tailwind.css', 'Android Studio', 'REDUX.JS', 'Electron', 'Nextron']
        const BE = ['PHP', 'Express.JS', 'NEST.JS', 'Java SpringBoot', '.NET Console', 'GraphQL', 'Flask.PY']
        const INFRA = ['AZURE IAM', 'Clerk', 'Stripe']
        const DB = ['Mysql', 'MongoDB (cloud)']
        const TUI = ['C (meson)', 'C++ (cmake + Meson)', 'C++ & Python - Pybind11', 'C++ & Javascript (Node-GYP)', 'Fortran']

        return (
            <div>
                <h1 align="center">Welcome to the website of Circuit Drone</h1>
                <br />
                <p><b>What is Circuit Drone?:</b> <i>No we are not a drone company, or a hardware company (although we do have personel who specialise in computer hardware), the name was just a mishap inspired by "circus krone, when the band 'eisbrecher' performed there", we are a software company (non financial), we've made websites, Social media bots and Programming plugins/modules along with some videos on youtube</i></p>

                <h2 align="center">Services</h2>
                <h3 align="center">FE</h3>

                <div class="grid">
                    {FE.map((i, b) =>
                        <Crd key={b} data={i} />
                    )}
                </div>
                <h3 align="center">DevOPS</h3>

                <div class="grid">
                    {ops.map((i, b) =>
                        <Crd key={b} data={i} />
                    )}
                </div>
                <h3 align="center">BE</h3>

                <div class="grid">
                    {BE.map((i, b) =>
                        <Crd key={b} data={i} />
                    )}
                </div>
                <h3 align="center">Infrastructure</h3>

                <div class="grid">
                    {INFRA.map((i, b) =>
                        <Crd key={b} data={i} />
                    )}
                </div>
                <h3 align="center">DB</h3>

                <div class="grid">
                    {DB.map((i, b) =>
                        <Crd key={b} data={i} />
                    )}
                </div>

                <h3 align="center">Service</h3>

                <div class="grid">
                    {TUI.map((i, b) =>
                        <Crd key={b} data={i} />
                    )}
                </div>
                <br />
                <br />
                <h2 align="center">Socials</h2>


                {/* <br /> */}
                {/* <br /> */}
                {/* <br /> */}
                {/* <br /> */}
                <div class="grid">
                    <div className="card">
                        {/*<img src="https://img.freepik.com/free-vector/instagram-icon_1057-2227.jpg?w=996&t=st=1711375922~exp=1711376522~hmac=acbe92a4278fc5ac0d970546a07c27ff143bf35a7a094b52f41cdd6693c91508"  alt="AA" />*/}
                        {/*<br />*/}
                        {/*<br />*/}
                        <h3>Instagram</h3>
                        <p>Feel free to Give a follow</p>
                        <br />
                        <a href="https://www.instagram.com/circuit.drone_9391"> <button className="btn btn-dark" >Visit ↗</button></a>
                        <br />
                    </div>
                    <div className="card">
                        {/*<img src="https://1000logos.net/wp-content/uploads/2017/02/Facebook-Logosu.png" alt="AA" />*/}
                        {/*<br />*/}
                        {/*<br />*/}
                        <h3>Facebook</h3>
                        <p>Feel free to Give a follow</p>
                        <br />
                        <a href="https://www.facebook.com/profile.php?id=61557124284100"> <button className="btn btn-dark" >Visit ↗</button></a>
                        <br />
                    </div>
                </div>
                <h2 align="center">Twitter</h2>
                <div class="grid">
                    <div className="card">
                        {/* <img src="https://twitter.com/CDrone9391/photo"  alt="AA" /> */}
                        {/* <br /> */}
                        {/* <br /> */}
                        <h3>Main</h3>
                        <p>Feel free to Give a follow</p>
                        <br />
                        <a href="https://twitter.com/Cdrone9391"> <button className="btn btn-dark" >Visit ↗</button></a>
                        <br />
                    </div>
                    <div className="card">
                        {/* <img src="https://twitter.com/CDrone9391/photo"  alt="AA" /> */}
                        {/* <br /> */}
                        {/* <br /> */}
                        <h3>Raus Nichts</h3>
                        <p>Feel free to Give a follow</p>
                        <br />
                        <a href="https://twitter.com/RausNichts"> <button className="btn btn-dark" >Visit ↗</button></a>
                        <br />
                    </div>
                    <div className="card">
                        {/* <img src="https://twitter.com/CDrone9391/photo"  alt="AA" /> */}
                        {/* <br /> */}
                        {/* <br /> */}
                        <h3>Fevid Acropolis</h3>
                        <p>Feel free to Give a follow</p>
                        <br />
                        <a href="https://twitter.com/FevidAcropolis"> <button className="btn btn-dark" >Visit ↗</button></a>
                        <br />
                    </div>
                    <div className="card">
                        {/* <img src="https://twitter.com/CDrone9391/photo"  alt="AA" /> */}
                        {/* <br /> */}
                        {/* <br /> */}
                        <h3>EntityToCode</h3>
                        <p>Feel free to Give a follow</p>
                        <br />
                        <a href="https://twitter.com/EntityToCode"> <button className="btn btn-dark" >Visit ↗</button></a>
                        <br />
                    </div>
                    <div className="card">
                        {/* <img src="https://twitter.com/CDrone9391/photo"  alt="AA" /> */}
                        {/* <br /> */}
                        {/* <br /> */}
                        <h3>Traum</h3>
                        <p>Feel free to Give a follow</p>
                        <br />
                        <a href="https://twitter.com/Traumbot"> <button className="btn btn-dark" >Visit ↗</button></a>
                        <br />
                    </div>

                </div>
                <h2 align="center">Personel</h2>

                <ul>
                    <li><b>GDS3 </b><a href='https://gdsimpson3.vercel.app'>Website,</a> GDS3 is a co founder of several divisions, GDS3 has been active during 2019~2024, GDS3 is active in divisions such as FEVID, ex-IBZ, ex-ibz-app Raus Nichts, Entity-to-code and more. but due to the bad circumstances of the tech world, GDS3 has pulled out of development and has pursued another career, but still contributes as a hobby/Part time.</li>
                    <li><b>BSW </b><a href='https://bsw9391.vercel.app'>Website,</a> BSW is another co-founder and has been active during 2022~2024 in various divisions such as FEVID, ex-IBZ-APP, Raus Nichts, entityToCode and others, BSW is also planning to leave the tech industry in retaliaion to the 'replacement of developer' movement</li>
                    <li><b>Tepid Neitzen </b><a href='https://tepid.vercel.app'>Website,</a> TEPID NEITZEN is a key member that has been active during 2020~2024 in various divisions such as FEVID, entitytocode, Raus nichts, ex-ibz-app and more, Tepid is also planning to leave the tech industry in retaliaion to the 'replacement of developer' movement</li>
                    <li><b>TTAKSHEEL </b><a href='https://ttaksheel.vercel.app'>Website,</a> TTAKSHEEL is a key member that has been active during 2021~2024 in various divisions such as FEVID, entitytocode, Raus nichts, WARTBURG and more, TTAKSHEEL is also planning to leave the tech industry in retaliaion to the 'replacement of developer' movement</li>
                </ul>

                <h2 align="center">History</h2>
                <p>It all started with the first division, IBZ (prev spsr) in 2019, which got broken in to 2 divisions in 2020, Raus nichts, now the small IBZ spawned another branch, the IBZ-APP division in 2020 which specialised in Native Apps, a new media Division called Wartburg was birthed in 2022, the IBZ divsion finally was suceeded by the new Fevid acropolis in 2023 which became a huge success, at that time IBZ-app had met it's sunset with IBZ but Raus Nichts was rising again, by late 2023 Raus nichts had 2 social media bots and a new division was founded, EntityToCode, by early 2024, fevid had halted it operation, and just maintained its existing sites, while Raus nichts had 3 bots and EntityToCode had 2 packages (pip, npm) and a mathematical website. and that brings us here.....</p>
                <br />
                <br />
                <sub>Product of Circuit Drone 9391, 2019~2024, international, </sub>
                <br />
                <br />

            </div>
        );
    }
}


function Crd(props) {
    // data.props = data
    return (
        <div className="card">
            {/*<img src="https://1000logos.net/wp-content/uploads/2017/02/Facebook-Logosu.png" alt="AA" />*/}
            {/*<br />*/}
            {/*<br />*/}
            <h3>{props.data}</h3>
            {/* <p>Feel free to Give a follow</p> */}
            {/* <br /> */}
            {/* <a href="https://www.facebook.com/profile.php?id=61557124284100"> <button className="btn btn-dark" >Visit ↗</button></a> */}
            {/* <br /> */}
        </div>)
}